import { ErrorBoundary } from '@sentry/react';
import { SideNav } from '../common/SideNav';
import { FallbackSideNav } from '../fallback/FallbackSideNav';
import { CrossPlatformSideNavLinks } from './CrossPlatformSideNavLinks';
import { CrossPlatformSideNavFooterLinks } from './CrossPlatformSideNavFooterLinks';

export const CrossPlatformSideNav = () => (
  <ErrorBoundary fallback={<FallbackSideNav />}>
    <span data-testid="cross-platform-side-nav" />
    <SideNav
      SideNavMainComponent={CrossPlatformSideNavLinks}
      SideNavFooterComponent={CrossPlatformSideNavFooterLinks}
    />
  </ErrorBoundary>
);
